import { useEffect } from 'react';

import { ReactComponent as IconWarning } from 'styles/images/icon_warning.svg';

import './modal.css';

export const CommonCenterModal = ({ title, subTitle, btnText, show, handleClose, boxItems = [] }) => {
  useEffect(() => {
    if (show) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  if (!show) return null;

  return (
    <div className='dimmed-popup-center'>
      <div className='pop-con-wrap'>
        <div className='pop-con'>
          <IconWarning className='icon_warning' />
          <p className='pop-tit'>{title}</p>
          <span className='pop-info-txt'>{subTitle}</span>
          {/* BOX UI  */}
          {boxItems.map((boxItem, index) => {
            return (
              <div className='pop-box-wrap' key={index}>
                <ul className='pop-list'>
                  <li>
                    <h3 className='body-tit-01'>{boxItem.title}</h3>
                    <p className='body-tit-04'>{boxItem.desc}</p>
                  </li>
                </ul>
              </div>
            );
          })}
        </div>
        <div className='pop-btm'>
          <button
            className='btn btm-btn-primary'
            onClick={() => {
              handleClose();
            }}
          >
            <span>{btnText}</span>
          </button>
        </div>
      </div>
    </div>
  );
};
